import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("user-token");
  return token ? (
    children
  ) : (
    <Navigate
      to="/login"
      state={{
        message: "Please login to continue.",
      }}
    />
  );
};

export default PrivateRoute;
